import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { db } from '../../../services/firebase';
import ContentListUpdate from './contentListUpdate';
import styled from 'styled-components'
import CorePageForm from './corepageform';

const TeamPageForm = () => {
    const [primaryText, setPrimaryText] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    const toggle = () => setModal(!modal);
    const docRef = db.collection("webPages").doc("team")

    useEffect(() => {
        ReturnTeamPageInformation();   
    }, []);

    const ReturnTeamPageInformation = () =>{
        docRef.onSnapshot((doc) => {
            if(doc.data()){
                const data = doc.data();
                if(data.primaryText){
                    setPrimaryText(data.primaryText);
                }
            }
            else{
                docRef.set({primaryText})
            }
        });
    }

    const UpdatePrimaryText = (text) => {
        docRef.update({ primaryText: text }).then(() => {
            setModalTitle("Text Content Updated");
            setModalMessage("Successfully updated text for Teams Page");
            toggle();
        })
        .catch((error) => {
            setModalTitle("Something went wrong");
            setModalMessage("An error occurred when trying to update text");
            toggle();
        });
    }

    return ( <React.Fragment><Container>
        <Row>
            <Col>
                <h1>Study Info & Team</h1>
            </Col>
        </Row>
        <Row>
            <Col>
                <h2>Left Side Content and Team Write Up</h2>
                 <ContentListUpdate returnDataCallback={UpdatePrimaryText} objectList={primaryText} />
            </Col>
        </Row>
        <Row>
            <Col>
                <StyledModal isOpen={modal}>
                    <ModalHeader>{modalTitle}</ModalHeader>
                        <ModalBody>
                            {modalMessage}
                        </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={toggle}>Done</Button>
                    </ModalFooter>
                </StyledModal>
            </Col>
        </Row>
    </Container>
    <CorePageForm />
    </React.Fragment> );
}
 
export default TeamPageForm;

const StyledModal = styled(Modal)`
    position: absolute;
    left: 40%;
    top: 40%;
`